let t = str => str;
export const GAME_EVENTS_MAP = {
    //    soccer
    1: t('Goal'),
    2: t('RedCard'),
    3: t('YellowCard'),
    4: t('Corner'),
    5: t('Penalty'),
    6: t('Substitution'),
    10: t('Period'),
    20: t('BallSafe'),
    21: t('DangerousAttack'),
    22: t('KickOff'),
    23: t('GoalKick'),
    24: t('FreeKick'),
    25: t('ThrowIn'),
    26: t('ShotOffTarget'),
    27: t('ShotOnTarget'),
    28: t('Offside'),
    29: t('GoalkeeperSave'),
    30: t('ShotBlocked'),
    100: t('NotStarted'),
    101: t('FirstHalf'),
    102: t('HalfTime'),
    103: t('SecondHalf'),
    104: t('PreExtraHalf'),
    105: t('ExtraTimeFirstHalf'),
    106: t('ExtraTimeHalfTime'),
    107: t('ExtraTimeSecondHalf'),
    108: t('Finished'),
    199: t('Timeout'),
    //    tennis
    200: t('FirstSet'),
    201: t('SecondSet'),
    202: t('ThirdSet'),
    203: t('FourthSet'),
    204: t('FifthSet'),
    205: t('Point'),
    206: t('BallInPlay'),
    207: t('ServiceFault'),
    208: t('DoubleFault'),
    209: t('Ace'),
    210: t('InjuryBreak'),
    211: t('RainDelay'),
    212: t('Challenge'),
    213: t('FinalSet'),
    214: t('Let1stServe'),
    215: t('Retired'),
    216: t('Walkover'),
    217: t('Game'),
    218: t('Set'),
    //    basketball
    300: t('FirstQuarter'),
    301: t('FirstQuarterEnded'),
    302: t('SecondQuarter'),
    303: t('SecondQuarterEnded'),
    304: t('ThirdQuarter'),
    305: t('ThirdQuarterEnded'),
    306: t('FourthQuarter'),
    307: t('FourthQuarterEnded'),
    308: t('OverTime'),
    309: t('OverTimeEnded'),
    320: t('Foul'),
    321: t('FreeThrow'),
    322: t('Free1Throw'),
    323: t('Free2Throws'),
    324: t('Free3Throws'),
    325: t('MissedFreeThrow'),
    326: t('Attack'),
    327: t('OnePoint'),
    328: t('TwoPoints'),
    329: t('ThreePoints'),
    //    icehockey
    400: t('FirstPeriod'),
    401: t('FirstPeriodEnded'),
    402: t('SecondPeriod'),
    403: t('SecondPeriodEnded'),
    404: t('ThirdPeriod'),
    405: t('ThirdPeriodEnded'),
    410: t('TimerStatus'),
    420: t('Suspension'),
    421: t('SuspensionOver'),
    //    handball
    500: t('Throw_In'),
    501: t('Throw_Out'),
    502: t('GoalKeeper_Throw'),
    503: t('Free_Throw'),
    504: t('SevenMeter_Throw'),
    505: t('PenaltyScored'),
    506: t('PenaltyMissed')
};